import * as jose from "jose";
let loginDialog: Office.Dialog;
const loginHTMLURL = window.location.host.startsWith("localhost")
  ? "/login.html" /* Development */
  : "/$web/app/login.html"; /* Deployed */
const dialogLoginUrl: string =
  location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + loginHTMLURL;

const jwkUrl = "https://login.eveonline.com/oauth/jwks";

export async function signIn(
  //setState: (x: AppState) => void,
  setTokenAndCharacter: (x: string, y: string) => void,
  displayError: (x: string) => void
) {
  await Office.context.ui.displayDialogAsync(dialogLoginUrl, { height: 60, width: 40 }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      displayError(`${result.error.code} ${result.error.message}`);
    } else {
      loginDialog = result.value;
      loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
      loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processLoginDialogEvent);
    }
  });

  async function processLoginMessage(arg: any) {
    let messageFromDialog = JSON.parse(arg.message);
    if (messageFromDialog.status === "success") {
      // We now have a valid access token.
      // Validate it using the jwks service from login.eveonline.com
      const jwt = messageFromDialog.result;
      const refreshtoken = messageFromDialog.refreshtoken;
      const JWKS = jose.createRemoteJWKSet(new URL(jwkUrl));
      const { payload, protectedHeader } = await jose.jwtVerify(jwt, JWKS, {
        issuer: ["login.eveonline.com", "https://login.eveonline.com"],
        audience: "EVE Online",
      });
      var message;
      // Payload is the decoded jwt, we're decoding on the frontend for characterID and name
      // the if statement here is possibly not enough
      if (protectedHeader && payload) {
        setTokenAndCharacter(jwt, refreshtoken);
        sessionStorage.setItem("token", refreshtoken);
      } else {
        message = "Error: " + protectedHeader + " (" + payload + ")";
        displayError(message);
      }
      loginDialog.close();
    } else {
      // Something went wrong with authentication or the authorization of the web application.
      loginDialog.close();
      displayError(messageFromDialog.result);
    }
  }

  function processLoginDialogEvent(arg: { message: string; origin: string | undefined } | { error: number }) {
    processDialogEvent(arg, displayError);
  }
}

const logoutHTMLURL = window.location.host.startsWith("localhost")
  ? "/logout.html" /* Development */
  : "/$web/app/logout.html"; /* Deployed */
let logoutDialog: Office.Dialog;
const dialogLogoutUrl: string =
  location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + logoutHTMLURL;

export async function signOut(
  //setState: (x: AppState) => void,
  clearTokenAndCharacter: (x: string) => void,
  displayError: (x: string) => void
) {
  clearTokenAndCharacter("logout");
  Office.context.ui.displayDialogAsync(dialogLogoutUrl, { height: 40, width: 30 }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      displayError(`${result.error.code} ${result.error.message}`);
    } else {
      logoutDialog = result.value;
      logoutDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLogoutMessage);
      logoutDialog.addEventHandler(Office.EventType.DialogEventReceived, processLogoutDialogEvent);
      clearTokenAndCharacter("logout");
      logoutDialog.close();
    }
  });

  function processLogoutMessage() {
    clearTokenAndCharacter("logout");
    logoutDialog.close();
  }

  function processLogoutDialogEvent(arg: { message: string; origin: string | undefined } | { error: number }) {
    processDialogEvent(arg, displayError);
  }
}

function processDialogEvent(
  arg: any,
  //setState: (x: AppState) => void,
  displayError: (x: string) => void
) {
  if (arg.error) {
    switch (arg.error) {
      case 12002:
        displayError(
          "The dialog box has been directed to a page that it cannot find or load, or the URL syntax is invalid."
        );
        break;
      case 12003:
        displayError("The dialog box has been directed to a URL with the HTTP protocol. HTTPS is required.");
        break;
      case 12006:
        // 12006 means that the user closed the dialog instead of waiting for it to close.
        // It is not known if the user completed the login or logout, so assume the user is
        // logged out and revert to the app's starting state. It does no harm for a user to
        // press the login button again even if the user is logged in.
        //setState({ authStatus: 'notLoggedIn' });
        break;
      default:
        displayError("Unknown error in dialog box.");
        break;
    }
  } else {
    displayError("");
  }
}
